import { AGENT, DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import FileAttachmentTheme from '../attachments/model/FileAttachmentTheme';
import QuickReplyTheme from '../quick-reply/model/QuickReplyTheme';
import Theme from '../theming/model/Theme';
import { FLINT, GYPSUM, HEFFALUMP, KOALA } from 'HubStyleTokens/colors';
const fileAttachmentTheme = FileAttachmentTheme({
  tileBackgroundColor: GYPSUM
});
export const buildMessageHistoryTheme = ({
  coloring: {
    accentColor,
    textColor,
    useDefaultColor
  } = {}
}) => ({
  [DEFAULT]: Theme({
    borderRadius: '0px 8px 8px 8px',
    borderWidth: '0px',
    fileAttachmentTheme
  }),
  [AGENT]: Theme({
    borderRadius: '0px 8px 8px 8px',
    borderWidth: '0px',
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? HEFFALUMP : accentColor,
    quickReplyTheme: QuickReplyTheme({
      borderColor: useDefaultColor ? FLINT : accentColor,
      color: useDefaultColor ? HEFFALUMP : textColor
    })
  }),
  [VISITOR]: Theme({
    alignItems: 'flex-end',
    backgroundColor: useDefaultColor ? KOALA : accentColor,
    borderColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '8px 0px 8px 8px',
    borderWidth: '0px',
    textColor: useDefaultColor ? HEFFALUMP : textColor,
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? HEFFALUMP : accentColor
  })
});